import React, { useEffect, useState } from 'react';
import { Progress } from 'antd';
import styles from './index.scss';

const Loading: React.FC = () => {
  const [show, setShow] = useState(false);
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    // 至少显示 500ms
    const timer = setTimeout(() => setShow(true), 500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (show) {
      const progressTimer = setInterval(() => {
        setPercent((prev) => Math.min(prev + 2, 90));
      }, 50);
      return () => clearInterval(progressTimer);
    }
  }, [show]);

  if (!show) return null;

  return (
    <div className={styles.loading}>
      <Progress
        percent={percent}
        showInfo={false}
        className={styles.progress}
      />
    </div>
  );
};

export default Loading;
